/** Only main occurrences explicitly marked for modelling are imported or displayed. */
export const DROFUS_MODELLED_MAIN_FILTER = "parent_occurrence_id eq null and article_id_to_be_drawn eq true";
export const DROFUS_SPECIFIED_ARTICLES_VERSION = "modelled-main-v1";
